// Number formatting utilities — identical in both portals (100% match)
// Source: apps/*/src/util/number-format.tsx

export interface FormatOptions {
  num: number;
  toFixedNum?: number;
  locale?: string;
  unit?: string;
  position?: "pre" | "post";
  abbreviation?: boolean;
}

export function formatNumberWithIntl(options: FormatOptions): string {
  const {
    num,
    toFixedNum = 1,
    locale = "en-US",
    unit = "$",
    position = "pre",
    abbreviation = true,
  } = options;

  if (typeof num !== "number" || typeof toFixedNum !== "number") {
    console.error("Invalid input:", { num, toFixedNum });
    throw new Error("Invalid input: both num and toFixedNum must be numbers");
  }

  const formatter = new Intl.NumberFormat(locale, {
    notation: abbreviation ? "compact" : "standard",
    compactDisplay: "short",
    maximumFractionDigits: toFixedNum,
    minimumFractionDigits: toFixedNum,
  });

  const formattedNum = formatter.format(num);

  return position === "pre"
    ? `${unit}${formattedNum}`
    : `${formattedNum}${unit}`;
}

export function formatDollar(value: string): string {
  const numberValue = Number(value.replace(/[^0-9.-]/g, ""));
  const isNegative = numberValue < 0;
  const formattedAmount = Math.abs(numberValue).toLocaleString();
  return `${isNegative ? "-" : ""}$${formattedAmount}`;
}
